module.exports = __webpack_public_path__ + "static/media/bg-saikrishna-sy.fe3b5569.jpg";